import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { TrustpilotWidgetTileModel } from '@/types/B2CcontentServerContract';
import colors from '@/styling/0-Settings/colors.js';
import TrustPilotWidget from '@/shared/content/blocks/trustpilot/Trustpilot.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrustpilotMicroStarWidgetTile',
  props: {
    content: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full flex flex-wrap justify-center items-center py-20",
    style: _normalizeStyle({ backgroundColor: __props.content.backgroundColorHexCode || _unref(colors).brandy })
  }, [
    _createVNode(TrustPilotWidget, {
      height: "20px",
      width: "100%",
      "hex-code": __props.content.backgroundColorHexCode,
      "template-id": "5419b732fbfb950b10de65e5",
      "trustpilot-business-unit-id": __props.content.trustpilotBusinessUnitId
    }, null, 8, ["hex-code", "trustpilot-business-unit-id"])
  ], 4))
}
}

})